import { every } from 'lodash';

import * as types from './constants';

export const initialState = {
  dataTable: [],
  allSelected: false,
  loading: false,
  count: 0,
  next: null,
  previous: null,
  curr_page: 1,
  errors_api: {},
  queryParsed: false,
  message: null
};

const actions = {
  // Get My Creators Groups
  [types.GET_MY_CREATORS_GROUPS_REQUEST]: (state, { payload }) => {
    if (payload?.skipStateUpdate) {
      return state;
    }

    const data = {
      ...state,
      dataTable: [],
      loading: true
    };

    return { ...data };
  },

  [types.GET_MY_CREATORS_GROUPS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      ...payload
    };

    return { ...data };
  },

  [types.GET_MY_CREATORS_GROUPS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_MY_CREATORS_GROUPS_RESET]: () => {
    return { ...initialState };
  },

  // Poll — background refresh, no loading reset
  [types.POLL_MY_CREATORS_GROUPS_REQUEST]: state => state,

  [types.POLL_MY_CREATORS_GROUPS_DONE]: (state, { payload }) => {
    const freshById = {};
    payload.dataTable.forEach(row => { freshById[row.id] = row; });

    const updatedDataTable = state.dataTable.map(row => {
      const fresh = freshById[row.id];
      if (!fresh) return row;
      return {
        ...fresh,
        select: row.select
      };
    });

    return { ...state, dataTable: updatedDataTable };
  },

  // Operations
  [types.TOGGLE_MY_CREATORS_GROUPS]: (state, { payload }) => {
    const newDataTable = state.dataTable.map(el => el.select.id === payload ? {
      ...el,
      select: { ...el.select, value: !el.select.value }
    } : el);

    const status = every(newDataTable, x => x.select.value);

    const data = {
      ...state,
      allSelected: status,
      dataTable: newDataTable
    };

    return { ...data };
  },

  [types.TOGGLE_ALL_MY_CREATORS_GROUPS]: (state, { payload }) => {

    if (payload && payload.reset) {
      const data = {
        ...state,
        allSelected: false,
        dataTable: state.dataTable.map(el => ({
          ...el,
          select: { ...el.select, value: false }
        }))
      };

      return { ...data };
    } else {
      const status = every(state.dataTable, x => x.select.value);

      const data = {
        ...state,
        allSelected: !status,
        dataTable: state.dataTable.map(el => ({
          ...el,
          select: { ...el.select, value: !status }
        }))
      };

      return { ...data };
    }
  },

  [types.MY_CREATORS_GROUPS_SET_PAGE]: (state, { payload }) => {

    const data = {
      ...state,
      curr_page: parseInt(payload) || 1,
      queryParsed: true
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};